import React from 'react';

import { Link } from '@wegroup/design-system';

interface Props {
  text: string;
  onClick: () => void;
}

const AddressSearchExtraButton: React.FC<React.PropsWithChildren<Props>> = ({
  text,
  onClick,
}) => {
  return (
    <Link
      variant="gray"
      textDecor="underline"
      cursor="pointer"
      onClick={onClick}
    >
      {text}
    </Link>
  );
};

export default AddressSearchExtraButton;
